var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-empty-state',{attrs:{"title":_vm.$options.i18n.title,"svg-path":_vm.emptyStateSvgPath,"description":_vm.$options.i18n.description,"secondary-button-text":_vm.$options.i18n.secondaryButtonText,"secondary-button-link":_vm.$options.DOC_PATH_SECURITY_CONFIGURATION}})
}
var staticRenderFns = []

export { render, staticRenderFns }